import getHost from "utils/getHost";
import Environments from "constants/Environments";

import { Environment } from "types";

export default (): string => {
  if (getHost().includes(Environments.STAGING.subdomain)) {
    return Environment.STAGING;
  }

  if (getHost().includes(Environments.PRODUCTION.domain)) {
    return Environment.PRODUCTION;
  }

  return Environment.DEVELOPMENT;
};
